var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-content-container"},[_c('div',{staticClass:"content-title-box"},[_c('span',{staticClass:"back-btn el-icon-back",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")]),_c('span',{domProps:{"textContent":_vm._s(_vm.$route.name)}})]),_c('div',{staticClass:"content-container-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }